import CoreResize from '../../mixins/core-resize'

// URL list
import URL from '../../../config.url'

export default
{
    name: 'app-floating-live',

    mixins: [
        CoreResize
    ],

    props:
    {
        contentGlobal: { type: Object },
        isHidden: { type: Boolean, default: true }
    },

    data()
    {
        return {
            isMuted: true,
            url: URL,
            isMutedBackup: true,
            isOverlayHidden: false,
            isHovered: false
        }
    },

    watch:
    {
        isMuted: 'onIsMutedChange',
        isHidden: 'onIsHiddenChange'
    },

    created()
    {
        this.TWITCH_OVERLAY_DURATION = 12000 // ms

        // Mousewheel
        this._isPointerDown = false
        this._pointerX = 0
        this._pointerStartX = 0
        this._pointerY = 0
        this._pointerStartY = 0
        this._pointerXOffset = 50
        //
    },

    mounted()
    {
        this._initTwitch()

        this.$nextTick(this.onResized)
    },

    destroyed()
    {
        if (this.player)
        {
            const Twitch = window.Twitch

            this.player.removeEventListener(Twitch.Player.READY, this._onReady)
        }
    },

    methods:
    {
        // CORE
        onResized()
        {
            this.videoMaxTranslate = (this.$root.width / 2) - this.$el.offsetWidth
        },

        // WATCHERS
        onIsMutedChange()
        {
            this.player.setMuted(this.isMuted)
        },

        onIsHiddenChange()
        {
            if (this.isHidden)
            {
                this.isMutedBackup = this.isMuted
                this.isMuted = true
            }
            else
            {
                this.isMuted = this.isMutedBackup
            }
        },

        _onReady()
        {
            // When player is ready changeits mute / unmute property
            setTimeout(this.onIsMutedChange, 500)

            setTimeout(() =>
            {
                this.isOverlayHidden = true
            }, this.TWITCH_OVERLAY_DURATION)
        },

        _initTwitch()
        {
            const Twitch = window.Twitch

            if (Twitch)
            {
                const options = {
                    width: '100%',
                    height: '100%',
                    playsinline: true,
                    channel: this.contentGlobal.twitch.channel
                }

                this.player = new Twitch.Player(this.$el.querySelector('.js-twitch-player'), options)

                // Add a READY listener to check when to mute / unmute the player
                // Only when it can receive function calls
                this.player.addEventListener(Twitch.Player.READY, this._onReady)
            }
            else
            {
                console.error('<page-watch-now> Twitch API not loaded')
            }
        },

        // HTML ACTIONS
        _onMouseenter()
        {
            if (!this.isOverlayHidden) return

            this.isHovered = true
        },

        _onMouseleave()
        {
            if (!this.isOverlayHidden) return

            this.isHovered = false
        },

        _onClick()
        {
            if (!this.isOverlayHidden) return

            this.isHovered = !this.isHovered
        },

        // ACTIONS
        _toggleIsMuted()
        {
            this.isMuted = !this.isMuted
        },

        _hide()
        {
            // Send event to app-main to hide the the floating live
            this.eventHub.$emit('toggle:is-floating-live-shown', false)
        },

        // SCROLL
        onTouchDown(event)
        {
            this._isPointerDown = true

            this._pointerStartY = event.touches[0].clientY
            this._pointerStartX = event.touches[0].clientX

            this._pointerY = this._pointerStartY
            this._pointerX = this._pointerStartX
        },

        onTouchMove(event)
        {
            if (!this._isPointerDown) return

            event.preventDefault()

            this.$el.classList.remove('is-coming-to-right')
            this.$el.classList.remove('is-disappearing')

            this._pointerY = event.touches[0].clientY
            this._pointerX = event.touches[0].clientX

            const translateX = (this._pointerStartX - this._pointerX) * -1

            const opacityMax = 1
            const opacityMin = 0.2
            let opacity = opacityMax - (Math.abs(this._pointerStartX - this._pointerX) / this.videoMaxTranslate) + opacityMin

            if (opacity < opacityMin) opacity = opacityMin
            else if (opacity > opacityMax) opacity = opacityMax

            this.$el.style.transform = `translateX(${translateX}px) translateZ(0)`
            this.$el.style.opacity = opacity
        },

        onTouchEnd(/* event */)
        {
            if (!this._isPointerDown) return

            this._isPointerDown = false

            if (this._pointerStartX - this._pointerX > this.videoMaxTranslate)
            {
                this.$el.classList.add('is-disappearing')
                this.$el.style.transform = 'translateX(-100vw) translateZ(0)'
                this.$el.style.opacity = 0

                setTimeout(() =>
                {
                    this.$el.classList.remove('is-disappearing')
                }, 1000)

                this._hide()
            }
            else
            {
                this.$el.classList.add('is-coming-to-right')
                this.$el.style.transform = 'translateX(0) translateZ(0)'
                this.$el.style.opacity = 1

                setTimeout(() =>
                {
                    this.$el.classList.remove('is-coming-to-right')
                }, 1000)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-floating-live/script.js